// (function($) {          
//     $(document).ready(function(){                    
//         $(window).scroll(function(){                          
//             if ($(this).scrollTop() > 200) {
//                 $('.public-header').fadeIn(500);
//             } else {
//                 $('.public-header').fadeOut(500);
//             }
//         });
//     });
// })(jQuery);
$(window).scroll(function(){
	$('.top-header').toggleClass('public-header', $(this).scrollTop() > 50);
});

var timer;
$(document).mousemove(function() {
    if (timer) {
        clearTimeout(timer);
        timer = 0;
    }
    $('#bottom-content-block:hidden').fadeIn();
    timer = setTimeout(function() {
        $('#bottom-content-block').fadeOut();
    }, 3000);
});
	